import React from "react";
import Typography from "@material-ui/core/Typography";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

require("dayjs/locale/en-gb");

class DynamicDatePickControl extends React.Component {
  render() {
    let field = this.props.field;
    const hideField = this.props.hideField;
    return (
      <>
        {!hideField &&
          <fieldset className="entity-fieldset">
            <Typography component="legend" color="primary">
              <legend>
                {field.IsMandatory ? "*" : ""}
                {field.FieldName}
              </legend>
            </Typography>
            <p dangerouslySetInnerHTML={{ __html: field.HelpText }}></p>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
              <DatePicker
                autoOk
                name={field.FieldCode}
                value={this.props.value ? dayjs(this.props.value) : null}
                error={this.props.fieldError ? true : false}
                onChange={date => this.props.eventHandle(date?.$d)}
                required={field.IsMandatory && !hideField}
                sx={{ width: '100%' }}
                format="DD-MMMM-YYYY"
                slotProps={{ textField: { variant: 'filled' } }}
              />
            </LocalizationProvider>
            <Typography variant="body2" color="error">
              {this.props.fieldError}
            </Typography>
          </fieldset>
        }
      </>
    );
  }
}

export default DynamicDatePickControl;
